import express = require("express");
import { inject, injectable } from "inversify";
import { ConsoleUI } from "../utils/ConsoleUI";
import TYPES from "../TYPES";
const opn = require('opn');
const clientId = "wTAxcHihLOrviwpilE5yBmBhegrIvqH5";
const callback = "http://localhost:3000/callback";
const myPort = 3000;

export interface AuthResult {
    accessToken: string;
}

/**
 * This class expose methods to signup/login
 */
@injectable()
export class AuthenticationServer {

    private ui: ConsoleUI;

    constructor(@inject(TYPES.ConsoleUI) ui: ConsoleUI) {
        this.ui = ui;
    }

    public getAuthenticationToken(): Promise<AuthResult> {

        // Resta di stucco - e' un barbatrucco!
        return new Promise((succees, reject) => {


            // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
            const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            const nonce = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            const responseType = "token%20id_token";
            const audience = 'https://kotenna.porketta.eu';
            const scope = "openid%20email";

            const loginUrl = `https://porketta.eu.auth0.com/authorize?response_type=${responseType}&client_id=${clientId}&redirect_uri=${callback}&state=${state}&audience=${audience}&scope=${scope}&nonce=${nonce}`;
            // Create Express server
            const app = express();
            const server = app.listen(3000, () => {
                this.ui.log("Please login in the browser:");
                this.ui.log(loginUrl);
                this.ui.log("");
                opn(loginUrl)
                    .catch(err => {
                        console.log(err);
                        this.ui.log(err);
                        this.ui.loaderFail(`Unfortunately we can't proceed with the remote login.\nPlease generate a token at https://dashboard.hakuna.cloud and run \nporcli user login -u <token_name> -p <token_password> `);
                        process.exit(1);
                    });
                this.ui.loaderStart("Waiting for the login");
            });


            app.get("/token", (req, res) => {

                if (state !== req.query.state) {
                    res.status(500).send("Invalid state");
                    this.ui.loaderFail("AUTHENTICATION ERROR");
                    return reject(new Error("Invalid state"));
                }
                this.ui.loaderSuccess("Logged in");
                res.send("ok");
                const accessToken = req.query.token;
                server.close();
                return succees({ accessToken });
            });

            app.get("/callback", (req, res) => {
                res.send(`
                <!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <title>Hakuna Cloud CLI | Authentication</title>
    <style>
        html,
        body {
            /*background: #347fc3;*/
            background: #fff;
            width: 100%;
            overflow-x: hidden;
            overflow-y: hidden;
            font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
        }

        .resultbox {
            margin: 0 auto;
            text-align: center;
        }

        .bar {
            position: relative;
            height: 2px;
            width: 500px;
            margin: 0 auto;
            background: #386dd9;
            margin-top: 150px;
        }

        .circle {
            position: absolute;
            top: -30px;
            margin-left: -30px;
            height: 60px;
            width: 60px;
            left: 0;
            background: #386dd9;
            border-radius: 30%;
            -webkit-animation: move 5s infinite;
        }

        p {
            position: absolute;
            top: -35px;
            right: -85px;
            text-transform: uppercase;
            color: black;
            font-family: helvetica, sans-serif;
            font-weight: bold;
        }

        @-webkit-keyframes move {
            0% {
                left: 0;
            }

            50% {
                left: 100%;
                -webkit-transform: rotate(450deg);
                width: 150px;
                height: 150px;
            }

            75% {
                left: 100%;
                -webkit-transform: rotate(450deg);
                width: 150px;
                height: 150px;
            }

            100 {
                right: 100%;
            }
        }
    </style>
    <script src="https://code.jquery.com/jquery-3.3.1.min.js"></script>
</head>

<body>
    <div class="resultbox">
        <h1 style="color:black; font-weight: 500; line-height: 1.2;">Hakuna Cloud</h1>
        <h2 style="color:black; font-weight: 500; line-height: 1.2;"> CLI Login</h2>
        <!--<img alt="hakuna cloud" src="data:image/png;base64,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" />-->
        <div id="success" style="display: none">
            <h1>Thanks!</h1>
            <h3>You can close this window now</h3>
        </div>
    </div>
    <div class="bar">
        <div class="circle"></div>
        <p>Loading</p>
    </div>

    <script>
        $(document).ready(function () {
            var hash = window.location.hash;
            var idx = hash.indexOf('#access_token');

            if (idx >= 0) {
                // has '#access_token' in URL
                var at_str = hash.substring(idx);
                var access_token = at_str.substring(at_str.indexOf('=') + 1).trim();
                if (access_token !== "") {
                    // we're good to go
                    $.ajax({
                        url: 'http://localhost:${myPort}/token?token=' + access_token,
                        success: function () {
                            $('#success').fadeIn();
                            window.close();   // The fade is just in case
                        }
                    });
                    $.get()
                } else {
                    console.error('This page found an empty access_token in the location hash.');
                }
            } else {
                console.error('This page expected an access_token in the location hash.');
            }

        });
    </script>

</body>

</html>
    `);
            });



        });

    }

}



// TODO A Pen By Mathieu Richard https://codepen.io/MathieuRichard/#

